import React, { useContext, useEffect } from 'react'; 
import { AuthContext } from './AuthContext';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const { logout, user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    // console.log(user)
    navigate('/'); 
  }, [logout, navigate]);

  return null; 
};

export default Logout;
